import React, { useState, useEffect } from 'react';
import { X, ArrowRight, Gift } from 'lucide-react';

export default function LeadCaptureBanner(): React.JSX.Element | null {
  const [show, setShow] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    const timer = setTimeout(() => {
      try {
        const dismissed = localStorage.getItem('leadPopupDismissed');
        if (!dismissed) setShow(true);
      } catch (e) {}
    }, 15000); // Show after 15 seconds
    return () => clearTimeout(timer);
  }, []);

  const openPopup = () => {
    setShow(false);
    // Dispatch custom event that LeadCapturePopup listens for
    window.dispatchEvent(new CustomEvent('openLeadPopup'));
  };

  const dismiss = () => {
    setShow(false);
  };

  if (!mounted || !show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[90] bg-white border-t border-slate-200 shadow-lg md:hidden">
      <div className="flex items-center gap-3 px-4 py-3">
        <div className="w-10 h-10 rounded-xl bg-amber-100 flex items-center justify-center flex-shrink-0">
          <Gift className="w-5 h-5 text-amber-600" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-slate-900 truncate">
            Free AI Finance Starter Kit
          </p>
          <p className="text-xs text-slate-500 truncate">
            PDF + Video — Join 2,000+ professionals
          </p>
        </div>
        <button
          onClick={openPopup}
          className="flex-shrink-0 px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white text-sm font-bold rounded-lg transition-colors flex items-center gap-1"
        >
          Get It
          <ArrowRight className="w-4 h-4" />
        </button>
        <button
          onClick={dismiss}
          className="flex-shrink-0 p-1.5 text-slate-400 hover:text-slate-600"
          aria-label="Dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
